<template>
    <div>
        <v-alert color="red-darken-4" variant="tonal" class="mt-1" border="left" border-color="red-darken-4"
            v-for="request in requests" :key="request.id">
            <div class="text-h6 text-red-darken-4 font-weight-bold">Attention!</div>
            <div>Vous avez une demande de paiement en attente pour cette commande</div>
            <div><b>Motif :</b> {{ request.motif }}</div>
            <div v-if="mainStore.module.base == 'TSB26'">
                <p>Vous avez été
                    très nombreux à vouloir vous inscrire en même temps au Trail
                    Sainte-Baume, et nous vous en remercions chaleureusement!<br />En raison de cet
                    afflux exceptionnel, certains d’entre vous n’ont pas
                    bénéficié du tarif approprié lors de l’inscription. En effet les tarifs
                    devaient être évolutifs en fonction du nombre d'inscrits et le changement de
                    tarif n'a pas pu s'actualiser en temps réel.</p>
            </div>
            <div>Au 27 Novembre 2025, sans régularisation de votre part, votre commande sera remboursée et supprimée.
            </div>
            <v-btn @click="goToPaymentLink(request)" variant="elevated" elevation="0" color="red-darken-4"
                class="mt-2">Procéder au
                paiement</v-btn>

        </v-alert>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
    computed: {
        ...mapStores(useMainStore),
    },
    props: ["requests"],
    methods: {
        goToPaymentLink(request) {
            this.$router.push({ name: 'PaymentLink', query: { req: request.token } });
        }
    }
}
</script>

<style lang="scss" scoped></style>